/**
 * Minimal pub/sub event bus.
 * Singleton instance shared across agents so they stay decoupled.
 */
class EventBus {
  constructor() {
    this.listeners = new Map();
  }

  on(event, fn) {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event).add(fn);
    return () => this.off(event, fn);
  }

  off(event, fn) {
    this.listeners.get(event)?.delete(fn);
  }

  emit(event, payload) {
    const set = this.listeners.get(event);
    if (!set) return;
    set.forEach((fn) => {
      try {
        fn(payload);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`[bus] listener error on "${event}":`, e);
      }
    });
  }

  clear() {
    this.listeners.clear();
  }
}

export const bus = new EventBus();

// Event name constants — single source of truth
export const EVENTS = {
  LANDMARKS_DETECTED: 'landmarks:detected',
  GESTURE_CANDIDATE: 'gesture:candidate',
  GESTURE_CONFIRMED: 'gesture:confirmed',
  PHRASE_READY: 'phrase:ready',
  SPEAKING_START: 'speaking:start',
  SPEAKING_END: 'speaking:end',
  FPS: 'fps:update',
  VISION_STATE: 'vision:state',
  HAND_STATUS: 'hand:status',
  TRACKING_DEGRADED: 'tracking:degraded',
  HANDS_COUNT: 'hands:count',
};
